import ApiRequest from "../index"

const complementsRequest = {
    get: async data => ApiRequest.get(`/v2/lojinha/complements/privacypolicy`),
    put: async data => ApiRequest.put(`/v2/lojinha/complements/privacypolicy`,{...data}),
}

export default complementsRequest